import { For } from "solid-js";
import { Spacer } from "~/components/Space";
import { quick } from "~/utils/app_state";
import { c, stylex } from "~/utils/styles";
import { AdminPageLayout } from "./AdminPageLayout";
import { CMText } from "./CMText";

const LINKS = [
	{
		text: "Move annotations",
		href: "/admin/move-annotations",
	},
	{
		text: "Eco codes",
		href: "/admin/eco-codes",
	},
];

export const AdminView = () => {
	return (
		<AdminPageLayout>
			<CMText style={stylex(c.fontSize(48))}>Admin</CMText>
			<Spacer height={24} />
			<div class="flex gap-4 items-start">
				<For each={LINKS}>
					{(link) => (
						<div
							class="cursor-pointer"
							use:onClick={() => {
								quick((s) => {
									s.navigationState.push(link.href);
								});
							}}
						>
							<CMText style={stylex(c.fg(c.primaries[50]), c.fontSize(24), c.weightBold)}>
								{link.text}
							</CMText>
						</div>
					)}
				</For>
			</div>
		</AdminPageLayout>
	);
};
